export enum ViewTypes {
	Card = 1,
	List = 2,
	// Continue numbers in the power's of 2, to allow OR operations.
	// Etc ViewType.Cards | ViewType.Lists
	// sequence 1, 2, 4, 8, 16, 32, e.t.c
}